var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "12.5 12.5 75 75",
    enableBackground: "new 12.5 12.5 75 75",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M79.2,12.5H20.8c-4.6,0-8.3,3.8-8.3,8.3v58.3c0,4.6,3.8,8.3,8.3,8.3h58.3c4.6,0,8.3-3.8,8.3-8.3V20.8 C87.5,16.3,83.8,12.5,79.2,12.5z M79.2,79.2H20.8V20.8h58.3V79.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedIcon);
export default __webpack_public_path__ + "static/media/unchecked-icon.a2af3f11b4105976c4d6e74e838f9e07.svg";
export { ForwardRef as ReactComponent };